module.exports = __webpack_public_path__ + "assets/media/stipe.bced2909.svg";